import { render, staticRenderFns } from "./SelectNotificationTemplate.vue?vue&type=template&id=02dcc89a"
import script from "./SelectNotificationTemplate.vue?vue&type=script&lang=js"
export * from "./SelectNotificationTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports